const EVENT_TYPES = new Set([
    'text',
    'tool_start',
    'tool_end',
    'citations',
    'suggestions',
    'done',
    'error',
]);
/** One SSE frame: `data: <json>\n\n`. */
export function encodeSseEvent(event) {
    return `data: ${JSON.stringify(event)}\n\n`;
}
/** Inverse of `encodeSseEvent` for the payload after `data: `. Throws on an unknown `type`. */
export function decodeSseData(data) {
    const parsed = JSON.parse(data);
    if (typeof parsed?.type !== 'string' || !EVENT_TYPES.has(parsed.type)) {
        throw new Error(`unknown event type: ${String(parsed?.type)}`);
    }
    return parsed;
}
//# sourceMappingURL=events.js.map